<template>
  <b-container>
    <b-row 
      align-v="center"
      style="height: 300px">
      <b-col><div class="mt-2"><h5>Primary</h5> <b-button
        variant="primary-light">Button</b-button></div>
        <b-button 
          variant="primary-light" 
          size="sm">Button</b-button>
        <div class="mt-2">
          <h5>Secondary</h5>
          <b-button variant="secondary-light">Button</b-button>
          <b-button 
            variant="secondary-light" 
            size="sm">Button</b-button>
        </div>
      </b-col>
      <b-col><b-button
        disabled
        variant="primary-light">Button</b-button></b-col><br>
      <b-button 
        disabled 
        variant="primary-light" 
        size="sm">Button</b-button>
      <div class="mt-2">
        <h5>Secondary</h5>
        <b-button 
          disabled 
          variant="secondary-light">Button</b-button>
        <b-button 
          disabled 
          variant="secondary-light" 
          size="sm">Button</b-button>
      </div>
    </b-row>
    <b-row 
      align-v="center"
      style="background-color:#282828; height: 300px">

      <b-col> <b-button
        variant="primary">Button</b-button>
        <div class="mt-2">
          <h5>Secondary</h5>
          <b-button variant="secondary">Button</b-button>
          <b-button 
            variant="secondary" 
            size="sm">Button</b-button>
        </div>
      </b-col>
      <b-col><b-button
        disabled
        variant="primary-light">Button</b-button></b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col 
        class="p-2  pt-5" 
        cols="5">
        <b-form>
          <b-form-group
            id="input-group-1"
            description="We'll never share your email with anyone else."
          >
            <b-form-input
              id="input-1"
              class="form-control-light"
              type="email"
              required
              placeholder="Enter email"
            />
          </b-form-group>

          <b-form-group id="input-group-2">
            <b-form-input
              id="input-2"
              :state="false"
              class="form-control-light"
              required
              placeholder="Enter name"
            />
            <b-form-invalid-feedback id="input-live-feedback">
              Enter at least 3 letters
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="input-group-4">
            <b-form-checkbox-group id="checkboxes-4">
              <b-form-checkbox value="me">Check me out</b-form-checkbox>
              <b-form-checkbox value="that">Check that out</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <b-button 
            type="submit" 
            variant="primary">Submit</b-button>
          <b-button 
            type="reset" 
            variant="danger">Reset</b-button>
        </b-form>
      </b-col>
      <b-col 
        style="background-color:#282828" 
        class="p-2 pt-5" 
        cols="5">
        <b-form>
          <b-form-group
            id="input-group-1"
            description="We'll never share your email with anyone else."
          >
            <b-form-input
              id="input-1"
              type="email"
              required
              placeholder="Enter email"
            />
          </b-form-group>

          <b-form-group id="input-group-2">
            <b-form-input
              id="input-2"
              :state="false"
              required
              placeholder="Enter name"
            />
            <b-form-invalid-feedback id="input-live-feedback">
              Enter at least 3 letters
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="input-group-4">
            <b-form-checkbox-group id="checkboxes-4">
              <b-form-checkbox value="me">Check me out</b-form-checkbox>
              <b-form-checkbox value="that">Check that out</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <b-button 
            type="submit" 
            variant="primary-light">Submit</b-button>
        </b-form>
      </b-col>
    </b-row>
    <b-row class="mt-4 light">
      <b-col cols="6">
        <h1 class="display-1">h1. Keven Smells</h1>
        <h2 class="display-2">h2. Keven Smells</h2>
        <h3 class="display-3">h3. Keven Smells</h3>

      </b-col>
      <b-col 
        class="light" 
        cols="6">
        <h1 class="">h1. Keven Really Smells</h1>
        <h2 class="">h2. Keven Really Smells</h2>
        <h3 class="">h3. Keven Really Smells</h3>
        <h4 class="">h4. Keven Really Smells</h4>
        <h5 class="">h5. Keven Really Smells</h5>
      </b-col>
      <p>A report on how much kevin <b>Smells</b> at 11am</p>
    </b-row>

    <b-row style="background-color:#282828;">
      <b-col cols="6">
        <h1 class="display-1">h1. Keven Smells</h1>
        <h2 class="display-2">h2. Keven Smells</h2>
        <h3 class="display-3">h3. Keven Smells</h3>
      </b-col>
      <b-col cols="6">
        <h1>h1. Keven Really Smells</h1>
        <h2>h2. Keven Really Smells</h2>
        <h3>h3. Keven Really Smells</h3>
        <h4>h4. Keven Really Smells</h4>
        <h5>h5. Keven Really Smells</h5>
      </b-col>
      <p>A report on how much kevin <b>Smells</b> at 11am</p>
    </b-row>
  </b-container>
</template>

<script>
    export default {
        name: 'DesignGuide',
    }
</script>



// WEBPACK FOOTER //
// src/components/DesignGuide.vue